import gql from 'graphql-tag'

export default gql`mutation ($data: AnnualLeaveInput!) {
  updateAnnualLeave(data: $data) @client
}`